var _path, _path2, _rect, _path3, _path4, _path5, _g, _path6, _path7, _g2, _g3, _path8, _path9, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRegistration = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 176,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.155 2.7L32.147 35.105c-5.201 1.491-8.208 6.917-6.717 12.118L57.835 160.23c1.491 5.201 6.916 8.209 12.117 6.717l113.009-32.404c5.201-1.492 8.208-6.917 6.717-12.118L157.273 9.417c-1.491-5.2-6.917-8.208-12.118-6.717z",
    fill: "#EAECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.79 16.439L5.655 52.894a4.898 4.898 0 00-3.358 6.059l6.75 23.543a4.898 4.898 0 006.06 3.359L142.24 49.398a4.899 4.899 0 003.359-6.059l-6.751-23.543a4.899 4.899 0 00-6.059-3.358z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.547,
    y: 56.33,
    width: 28.41,
    height: 28.41,
    rx: 4,
    transform: "rotate(-16.22 4.547 56.33)",
    fill: "#E3D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.887 69.556l-3.224 5.87 9.093-2.646a2.374 2.374 0 001.612-2.934 2.374 2.374 0 00-2.935-1.612l-4.546 1.322zM20.632 60.515l-7.069 12.868a1.194 1.194 0 00-.098.891l.774 2.66c.182.625.842.988 1.467.806l2.66-.774c.307-.089.555-.297.711-.564l7.069-12.868-5.514-3.02zM28.471 59.282a1.179 1.179 0 00-.466-1.603l-3.433-1.886a1.179 1.179 0 00-1.603.467l-1.475 2.685 5.503 3.022 1.474-2.685z",
    fill: "#6A3BD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.085 43.145L43.6 50.166a2.94 2.94 0 101.62 5.65l24.486-7.02a2.94 2.94 0 00-1.62-5.65z",
    fill: "#D0D5DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.547 50.527L47.11 62.408a2.94 2.94 0 001.62 5.65l41.436-11.88a2.94 2.94 0 10-1.62-5.651z",
    fill: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__filter0_d_552_1880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.759 81.777l127.134-36.455a4.898 4.898 0 016.059 3.358l6.751 23.544a4.898 4.898 0 01-3.358 6.059L67.21 114.738a4.898 4.898 0 01-6.059-3.359l-6.75-23.543a4.899 4.899 0 013.358-6.059z",
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.189 72.029l-24.485 7.02a2.94 2.94 0 101.62 5.651l24.485-7.021a2.939 2.939 0 10-1.62-5.65z",
    fill: "#D0D5DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.65 79.41L99.214 91.292a2.939 2.939 0 001.62 5.65l41.437-11.881a2.94 2.94 0 00-1.621-5.65z",
    fill: "#EAECF0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_552_1880)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.687,
    y: 85.14,
    width: 28.41,
    height: 28.41,
    rx: 4,
    transform: "rotate(-16 56.687 85.14)",
    fill: "#E0FFC8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.543,
    y: 88.386,
    width: 20.124,
    height: 4.735,
    rx: 2.368,
    transform: "rotate(-16 62.543 88.386)",
    fill: "#30A76A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.501,
    y: 95.214,
    width: 20.124,
    height: 4.735,
    rx: 2.368,
    transform: "rotate(-16 64.501 95.214)",
    fill: "#30A76A"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 66.459,
    y: 102.041,
    width: 13.835,
    height: 4.735,
    rx: 2.368,
    transform: "rotate(-16 66.459 102.041)",
    fill: "#30A76A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__filter1_d_552_1880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.875 133.883L156.01 97.428a4.898 4.898 0 016.059 3.359l6.751 23.543a4.898 4.898 0 01-3.359 6.059L38.327 166.844a4.901 4.901 0 01-6.059-3.358l-6.751-23.544a4.898 4.898 0 013.358-6.059z",
    fill: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.307 124.135l-24.485 7.021a2.939 2.939 0 101.62 5.65l24.485-7.021a2.939 2.939 0 10-1.62-5.65z",
    fill: "#D0D5DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.769 131.517l-41.437 11.881a2.94 2.94 0 001.62 5.651l41.437-11.882a2.938 2.938 0 10-1.62-5.65z",
    fill: "#EAECF0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip1_552_1880)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.807,
    y: 137.25,
    width: 28.41,
    height: 28.41,
    rx: 4,
    transform: "rotate(-16 27.807 137.25)",
    fill: "#FFEBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.406 152.193c-1.138.327-1.983 1.672-1.623 2.929.36 1.257 1.79 1.949 2.928 1.623l10.241-2.937a2.374 2.374 0 001.624-2.928 2.374 2.374 0 00-2.929-1.623l-10.24 2.936z",
    fill: "#FF905F",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.449 145.366c-1.138.326-1.984 1.672-1.624 2.928.36 1.257 1.79 1.95 2.929 1.624l10.24-2.937a2.374 2.374 0 001.624-2.928 2.374 2.374 0 00-2.928-1.623l-10.241 2.936zM40.49 138.539c-1.137.326-1.983 1.671-1.622 2.928.36 1.257 1.79 1.95 2.928 1.623l10.241-2.936a2.375 2.375 0 001.623-2.929 2.375 2.375 0 00-2.928-1.623l-10.241 2.937zM33.383 141.298l.923 3.219 3.219-.923-.923-3.219-3.219.923zM35.09 147.986l.923 3.219 3.218-.923-.923-3.219-3.218.923z",
    fill: "#FF905F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.047 154.814l.923 3.218 3.219-.923-.923-3.218-3.218.923z",
    fill: "#FF905F",
    opacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_552_1880"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.687,
    y: 85.14,
    width: 28.41,
    height: 28.41,
    rx: 4,
    transform: "rotate(-16 56.687 85.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip1_552_1880"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.807,
    y: 137.25,
    width: 28.41,
    height: 28.41,
    rx: 4,
    transform: "rotate(-16 27.807 137.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__filter0_d_552_1880",
    x: 52.211,
    y: 43.132,
    width: 153.682,
    height: 79.796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_552_1880"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_552_1880",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__filter1_d_552_1880",
    x: 23.327,
    y: 95.238,
    width: 153.682,
    height: 79.796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_552_1880"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_552_1880",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRegistration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/registration.f08bbd94cc6758b8b8220d81a8a54b63.svg";